var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './SavingsIndicator.styled';
/**
 * Displays information about a product variant, with opt-in interactivity by providing `onQuantityUpdate`.
 */
var SavingsIndicator = function (_a) {
    var _b = _a.discountTitle, discountTitle = _b === void 0 ? '' : _b, props = __rest(_a, ["discountTitle"]);
    return (React.createElement(Styled.SavingsIndicator, __assign({}, props),
        React.createElement(Styled.IconContainer, null,
            React.createElement(Styled.CheckIcon, { name: "check" })),
        React.createElement(Styled.IndicatorText, null, "".concat(discountTitle))));
};
SavingsIndicator.propTypes = {
    /**
     * Title of the discount applied to the product variant
     */
    discountTitle: PropTypes.string
};
SavingsIndicator.defaultProps = {
    discountTitle: null
};
export default SavingsIndicator;
